import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BarChartTwo } from "../../../../Constant";
import { BAR_ONE_CHART_DATA, BAR_ONE_CHART_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const BarChart2 = () => {
  return (
    <Col sm="12" xl="6" className="box-col-12">
      <Card>
        <CommonCardHeader title={BarChartTwo} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="bar-chart2">
            <Chart chartType="BarChart" width="100%" height="400px" data={BAR_ONE_CHART_DATA} options={BAR_ONE_CHART_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BarChart2;
